import { render, staticRenderFns } from "./Disbursement.vue?vue&type=template&id=ef422992&scoped=true"
import script from "./Disbursement.vue?vue&type=script&lang=js"
export * from "./Disbursement.vue?vue&type=script&lang=js"
import style0 from "./Disbursement.vue?vue&type=style&index=0&id=ef422992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef422992",
  null
  
)

export default component.exports